import { ChangeDetectorRef, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { BugReportService } from '../../services/bug-report.service';

@Component({
  selector: 'sous-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent extends FieldType {

  result: string[] = [];

  constructor(
    private readonly bugReportService: BugReportService,
    private readonly cdr: ChangeDetectorRef,
  ) {
    super();
  }

  /**
   * Convert selected images to base64 strings and send them to the BugReportService
   */
  onChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files: FileList | null = target.files;

    if (!files || files.length === 0) {
      return;
    }

    const total = files.length;
    let processed = 0;

    Array.from(files).forEach((file: File) => {
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const base64 = e.target?.result as string;
        this.result.push(base64);
        processed += 1;

        // Once all the files are processed – emit array to service
        if (processed === total) {
          this.bugReportService.fileForUpload.next(this.result.slice());
          // Ensure view updates with new previews
          this.cdr.detectChanges();
        }
      };
      reader.readAsDataURL(file);
    });
  }
}
